import styled from "@emotion/styled";

const List = styled.ul`
  display: flex;

  gap: 16px;
  flex-direction: column;
  margin-bottom: 24px;
`;

const Item = styled.li`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  font-size: 18px;

  color: ${p => p.theme.colors.secondary.gray};
  @media (min-width: ${prop => prop.theme.screenSizes.mdMax}) {
    gap: 24px;
    flex-direction: row;
  }
`;

const SpanStyled = styled.span`
  margin-bottom: 6px;

  @media (min-width: ${prop => prop.theme.screenSizes.mdMax}) {
    width: 150px;
    margin-bottom: 0;
  }
`;
export { List, Item, SpanStyled };
